import { Input, Component } from '@angular/core';

@Component({
    selector: 'loading-dots',
    template: `
        <ul class="pi-loadingDots" [ngClass]="dotColor()">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>
        @if (dimensions) {
            <div [ngStyle]="getSize()"></div>
        }
    `,
    standalone: false
})
export class LoadingDotsComponent {
    @Input()
    dimensions?: { width?: number; height?: number };
    @Input()
    colorName?: string;

    get propertiesList(): string[] {
        return ['dimensions', 'colorName'];
    }

    getSize() {
        return {
            width: this.dimensions.width
                ? `${this.dimensions.width}px`
                : 'auto',
            height: this.dimensions.height
                ? `${this.dimensions.height}px`
                : 'auto'
        };
    }

    dotColor() {
        return this.colorName ? `pi-loadingDots--${this.colorName}` : '';
    }
}
